//
import Globais from '../components/Globais/Globais';
import Axios from 'axios';
import { codificaSenha, defineCodigoFrontend, defineCodigoOrdem, toBase64 } from '../services/funcoes.js';
import { v4 as uuidv4 } from 'uuid';
import { useUploadProgress } from '../contexts/UploadProgressProvider.js';
import { toast } from 'react-toastify';

//Login via apiGateway
export const userLogin = async (user, password) => {
  const url = Globais.url_consulta
  const tabela = "Tab_Usuarios";
  const campos = "cod_usuario as codigo, cod_empresa as codigoEmpresa, user_name as userName, nom_usuario as nome, sen_usuario as senha, per_usuario as perfil, sit_usuario as situacao";

  const senhaCriptografada = await codificaSenha(password);
  console.log("Senha Criptografada: ", senhaCriptografada);

  const condicao = "user_name = '" + user + "' AND sen_usuario = '" + senhaCriptografada + "'";
  const orderBy = "";

  const response = await Axios.post(url,
    {
      tabela: tabela,
      campos: campos,
      condicao: condicao,
      orderBy: orderBy
    }
  );

  console.log('Response em Login: ', response);
  
  if (response.data.statusCode !== 200) { return []; }

  return JSON.parse(response.data.body);
};

//Clientes do Usuário
export const permissoesUser = async (userId) => {
  const url = Globais.url_consulta

  const tabela = "Tab_CliUsuario a, Tab_Clientes b";
  const campos = "a.cod_cliente as cod_cliente, a.per_usucliente as per_usucliente, b.nom_cliente as nom_cliente, b.idt_cliente as idt_cliente";
  const condicao = "a.cod_usuario = " + userId + " and b.cod_cliente = a.cod_cliente";
  const orderBy = "";

  const response = await Axios.post(url,
    {
      tabela: tabela,
      campos: campos,
      condicao: condicao,
      orderBy: orderBy
    }
  );

  if (response.data.statusCode !== 200) { return []; }

  return JSON.parse(response.data.body);
};

// Permissões do Perfil
export const permissoesPerfil = async (perfilId) => {
  const url = Globais.url_consulta

  const tabela = "Tab_PerPerfil";
  const campos = "cod_permissao";
  const condicao = "cod_perfil = '" + perfilId + "'";
  const orderBy = "";

  const response = await Axios.post(url,
    {
      tabela: tabela,
      campos: campos,
      condicao: condicao,
      orderBy: orderBy
    }
  );

  if (response.data.statusCode !== 200) { return null; }

  return response.data.body;
};

// Listar todos os Clientes
export const listarClientes = async () => {
  // const response = await fetch(`${API_URL}/clientes`, {
  //   method: "GET",
  // });

  // return response.json();
  const url = Globais.url_consulta

  const tabela = "Tab_Clientes";
  const campos = "cod_cliente, idt_cliente, nom_cliente, loc_cliente, sit_cliente";
  const condicao = "";
  const orderBy = "nom_cliente";

  const response = await Axios.post(url, {
    tabela: tabela,
    campos: campos,
    condicao: condicao,
    orderBy: orderBy
  });

  if (response.data.statusCode !== 200) { return []; }

  return JSON.parse(response.data.body);
};

/* DESVIOS */
// Busca Desvios
export const listarDesvios = async (clienteId) => {
  const url = Globais.url_consulta

  const tabela = "Tab_Desvios";
  const campos = "cod_desvio, des_desvio, sit_desvio";
  const condicao = "cod_cliente = " + clienteId;
  const orderBy = "cod_desvio";

  const response = await Axios.post(url, {
    tabela: tabela,
    campos: campos,
    condicao: condicao,
    orderBy: orderBy
  });

  if (response.data.statusCode !== 200) { return []; }

  return JSON.parse(response.data.body);
};

// Busca Desvio
export const buscarDesvio = async (clienteId, desvioId) => {
  const url = Globais.url_consulta

  const tabela = "Tab_Desvios";
  const campos = "cod_desvio, des_desvio, sit_desvio";
  const condicao = "cod_cliente = " + clienteId + " AND cod_desvio = " + desvioId;
  const orderBy = "";

  const response = await Axios.post(url, {
    tabela: tabela,
    campos: campos,
    condicao: condicao,
    orderBy: orderBy
  });

  if (response.data.statusCode !== 200) { return []; }

  return JSON.parse(response.data.body);
};

// incluir Desvio
export const incluirDesvio = async (clienteId, desvio) => {
  const url = Globais.url_inclusao

  let novoCodigo = await defineCodigoFrontend('Tab_Desvios', 'cod_desvio', `cod_cliente = ${clienteId}`);

  const tabela = "Tab_Desvios";
  const campos = "cod_cliente, cod_desvio, des_desvio, sit_desvio"
  const valores = clienteId + ", " + novoCodigo + ", '" + desvio.descricao + "', '" + desvio.situacao + "'";

  const response = await Axios.post(url, { tabela: tabela, campos: campos, valores: valores });

  return response.data.statusCode;
};

// Alterar Desvio
export const alterarDesvio = async (clienteId, desvio) => {
  const url = Globais.url_alteracao

  const tabela = "Tab_Desvios";
  const valores = "des_desvio = '" + desvio.descricao + "', sit_desvio = '" + desvio.situacao + "'";
  const condicao = "cod_cliente = " + clienteId + " AND cod_desvio = " + desvio.codigo;

  const response = await Axios.post(url, { tabela: tabela, valores: valores, condicao: condicao });

  return response.data.statusCode;
};

// Excluir Desvio
export const excluirDesvio = async (clienteId, desvioId) => {
  const url = Globais.url_exclusao

  const tabela = "Tab_Desvios";
  const condicao = "cod_cliente = " + clienteId + " AND cod_desvio = " + desvioId;

  const response = await Axios.post(url, { tabela: tabela, condicao: condicao });

  return response.data.statusCode;
};

/* FLUIDOS */
// Busca Fluidos
export const listarFluidos = async (clienteId) => {
  const url = Globais.url_consulta

  const tabela = "Tab_Fluidos";
  const campos = "cod_fluido, nom_fluido, sit_fluido";
  const condicao = "cod_cliente = " + clienteId;
  const orderBy = "cod_fluido";

  const response = await Axios.post(url, {
    tabela: tabela,
    campos: campos,
    condicao: condicao,
    orderBy: orderBy
  });

  if (response.data.statusCode !== 200) { return []; }

  return JSON.parse(response.data.body);
};

// Busca Fluido
export const buscarFluido = async (clienteId, fluidoId) => {
  const url = Globais.url_consulta

  const tabela = "Tab_Fluidos";
  const campos = "cod_fluido, nom_fluido, sit_fluido";
  const condicao = "cod_cliente = " + clienteId + " AND cod_fluido = " + fluidoId;
  const orderBy = "";

  const response = await Axios.post(url, {
    tabela: tabela,
    campos: campos,
    condicao: condicao,
    orderBy: orderBy
  });

  if (response.data.statusCode !== 200) { return []; }

  return JSON.parse(response.data.body);
};

// incluir Fluido
export const incluirFluido = async (clienteId, fluido) => {
  const url = Globais.url_inclusao

  let novoCodigo = await defineCodigoFrontend('Tab_Fluidos', 'cod_fluido', `cod_cliente = ${clienteId}`);

  const tabela = "Tab_Fluidos";
  const campos = "cod_cliente, cod_fluido, nom_fluido, sit_fluido";
  const valores = clienteId + ", " + novoCodigo + ", '" + fluido.nome + "', '" + fluido.situacao + "'";

  const response = await Axios.post(url, { tabela: tabela, campos: campos, valores: valores });

  return response.data.statusCode;
};

// Alterar Fluido
export const alterarFluido = async (clienteId, fluido) => {
  const url = Globais.url_alteracao

  const tabela = "Tab_Fluidos";
  const valores = "nom_fluido = '" + fluido.nome + "', sit_fluido = '" + fluido.situacao + "'";
  const condicao = "cod_cliente = " + clienteId + " AND cod_fluido = " + fluido.codigo;

  const response = await Axios.post(url, { tabela: tabela, valores: valores, condicao: condicao });

  return response.data.statusCode;
};

// Excluir Fluido
export const excluirFluido = async (clienteId, fluidoId) => {
  const url = Globais.url_exclusao

  const tabela = "Tab_Fluidos";
  const condicao = "cod_cliente = " + clienteId + " AND cod_fluido = " + fluidoId;

  const response = await Axios.post(url, { tabela: tabela, condicao: condicao });

  return response.data.statusCode;
};

/* EQUIPAMENTOS */
// Busca Equipamentos
export const listarEquipamentos = async (clienteId) => {
  const url = Globais.url_consulta

  const tabela = "Tab_Equipamentos";
  const campos = "cod_equipamento, mod_equipamento, tag_equipamento, sit_equipamento";
  const condicao = "cod_cliente = " + clienteId;
  const orderBy = "mod_equipamento, tag_equipamento";

  const response = await Axios.post(url, {
    tabela: tabela,
    campos: campos,
    condicao: condicao,
    orderBy: orderBy
  });

  // console.log('Response em ListarEquipamentos: ', response);

  if (response.data.statusCode !== 200) { return []; }

  return JSON.parse(response.data.body);
};

// Busca Equipamento
export const buscarEquipamento = async (clienteId, equipamentoId) => {
  const url = Globais.url_consulta

  const tabela = "Tab_Equipamentos";
  const campos = "mod_equipamento, tag_equipamento, sit_equipamento";
  const condicao = "cod_cliente = " + clienteId + " AND cod_equipamento = " + equipamentoId;
  const orderBy = "";

  const response = await Axios.post(url, {
    tabela: tabela,
    campos: campos,
    condicao: condicao,
    orderBy: orderBy
  });

  if (response.data.statusCode !== 200) { return []; }

  return JSON.parse(response.data.body);
};

// incluir Equipamento
export const incluirEquipamento = async (clienteId, equipamento) => {
  const url = Globais.url_inclusao

  let novoCodigo = await defineCodigoFrontend('Tab_Equipamentos', 'cod_equipamento', `cod_cliente = ${clienteId}`);

  const tabela = "Tab_Equipamentos";
  const campos = "cod_cliente, cod_equipamento, mod_equipamento, tag_equipamento, sit_equipamento"
  const valores = clienteId + ", " + novoCodigo + ", '" + equipamento.modelo + "', '" + equipamento.tag + "', '" + equipamento.situacao + "'";

  const response = await Axios.post(url, { tabela: tabela, campos: campos, valores: valores });

  return response.data.statusCode;
};

// Definir o Número do Lote do Equipamento
export const definirNumeroLote = async (clienteId, tipo) => {
  const url = Globais.url_consulta

  const tabela = "Tab_Equipamentos";
  const campos = "(Coalesce(Max(Right(Tag_Equipamento, 3)), 0) + 1) as lote";
  const condicao = "cod_cliente = " + clienteId + " AND mod_equipamento = '" + tipo + "'";
  const orderBy = "";

  const response = await Axios.post(url, {
    tabela: tabela,
    campos: campos,
    condicao: condicao,
    orderBy: orderBy
  });

  console.log('response DefineLote: ', response);

  if (response.data.statusCode !== 200) { return ''; }

  const result = JSON.parse(response.data.body);
  return result[0].lote;
};

// Alterar Equipamento
export const alterarEquipamento = async (clienteId, equipamento) => {
  const url = Globais.url_alteracao

  const tabela = "Tab_Equipamentos";
  const valores = "mod_equipamento = '" + equipamento.modelo + "', tag_equipamento = '" + equipamento.tag + "', sit_equipamento = '" + equipamento.situacao + "'";
  const condicao = "cod_cliente = " + clienteId + " AND cod_equipamento = " + equipamento.codigo;

  const response = await Axios.post(url, { tabela: tabela, valores: valores, condicao: condicao });

  return response.data.statusCode;
};

// Excluir Equipamento
export const excluirEquipamento = async (clienteId, equipamentoId) => {
  const url = Globais.url_exclusao

  const tabela = "Tab_Equipamentos";
  const condicao = "cod_cliente = " + clienteId + " AND cod_equipamento = " + equipamentoId;

  const response = await Axios.post(url, { tabela: tabela, condicao: condicao });

  return response.data.statusCode;
};

/* COMPARTIMENTOS */
// Listar Compartimentos
export const listarCompartimentos = async (clienteId, equipamentoId) => {
  const url = Globais.url_consulta

  const tabela = "Tab_Compartimentos";
  const campos = "cod_compartimento, tip_compartimento, tip_oleo, cap_compartimento, sit_compartimento";
  const condicao = "cod_cliente = " + clienteId + ' AND cod_equipamento = ' + equipamentoId;
  const orderBy = "cod_compartimento";

  const response = await Axios.post(url, {
    tabela: tabela,
    campos: campos,
    condicao: condicao,
    orderBy: orderBy
  });

  // console.log('Response em ListarCompartimentos: ', response);

  if (response.data.statusCode !== 200) { return []; }

  return JSON.parse(response.data.body);
};

// Buscar Compartimento
export const buscarCompartimento = async (clienteId, equipamentoId, compartimentoId) => {
  const url = Globais.url_consulta

  const tabela = "Tab_Compartimentos";
  const campos = "tip_compartimento, tip_oleo, cap_compartimento, sit_compartimento";
  const condicao = "cod_cliente = " + clienteId + " AND cod_equipamento = " + equipamentoId + " AND cod_compartimento = " + compartimentoId;
  const orderBy = "";

  const response = await Axios.post(url, {
    tabela: tabela,
    campos: campos,
    condicao: condicao,
    orderBy: orderBy
  });

  if (response.data.statusCode !== 200) { return []; }

  return JSON.parse(response.data.body);
};

// Incluir Compartimento
export const incluirCompartimento = async (clienteId, equipamentoId, compartimento) => {
  const url = Globais.url_inclusao

  let novoCodigo = await defineCodigoFrontend('Tab_Compartimentos', 'cod_compartimento', `cod_cliente = ${clienteId} AND cod_equipamento = ${equipamentoId}`);

  const tabela = "Tab_Compartimentos";
  const campos = "cod_cliente, cod_equipamento, cod_compartimento, tip_compartimento, tip_oleo, cap_compartimento, sit_compartimento"
  const valores = clienteId + ", " + equipamentoId + ", " + novoCodigo + ", '" + compartimento.tipo + "', '" + compartimento.fluido + "', " + compartimento.capacidade + ", '" + compartimento.situacao + "'";

  const response = await Axios.post(url, { tabela: tabela, campos: campos, valores: valores });

  return response.data.statusCode;
};

// Alterar compartimento
export const alterarCompartimento = async (clienteId, equipamentoId, compartimentoId, compartimento) => {
  const url = Globais.url_alteracao

  const tabela = "Tab_Compartimentos";
  const valores = "tip_compartimento = '" + compartimento.tipo
    + "', tip_oleo = '" + compartimento.fluido
    + "', cap_compartimento = " + compartimento.capacidade
    + ", sit_compartimento = '" + compartimento.situacao + "'";

  const condicao = "cod_cliente = " + clienteId
    + " AND cod_equipamento = " + equipamentoId
    + " AND cod_compartimento = " + compartimentoId

  const response = await Axios.post(url, { tabela: tabela, valores: valores, condicao: condicao });

  return response.data.statusCode;
};

// Excluir compartimento
export const excluirCompartimento = async (clienteId, equipamentoId, compartimentoId) => {
  const url = Globais.url_exclusao

  const tabela = "Tab_Compartimentos";
  const condicao = "cod_cliente = " + clienteId
    + " AND cod_equipamento = " + equipamentoId
    + " AND cod_compartimento = " + compartimentoId;

  const response = await Axios.post(url, { tabela: tabela, condicao: condicao });

  return response.data.statusCode;
};

/* TIPOS DE COMPARTIMENTOS */
// Busca Tipo de Compartimento
export const listarTipoCompartimento = async (clienteId) => {
  const url = Globais.url_consulta

  const tabela = "Tab_TipCompartimento";
  const campos = "cod_tipcompartimento, des_tipcompartimento, sit_tipcompartimento";
  const condicao = "";
  const orderBy = "";

  const response = await Axios.post(url, {
    tabela: tabela,
    campos: campos,
    condicao: condicao,
    orderBy: orderBy
  });

  if (response.data.statusCode !== 200) { return []; }

  return JSON.parse(response.data.body);
};

//ORDENS DE MANUTENÇÃO
// Listar Ordens de Manutenção
export const listarOrdens = async (clienteId, dataInicial, dataFinal) => {
  const url = Globais.url_consulta

  const tabela = "Tab_OrdManutencao";
  const campos = "cod_ordmanutencao, num_ordmanutencao, COALESCE(res_ordmanutencao, '') AS res_ordmanutencao, "
    + "DATE_FORMAT(dat_horinicial, '%d/%m/%Y %H:%i') AS dat_horinicial, sit_ordmanutencao";

  let condicao = "cod_cliente = " + clienteId;

  if (dataInicial && dataFinal) {
    condicao += ` AND dat_horinicial between '${dataInicial}' AND '${dataFinal}' `
  }

  const orderBy = "DATE_FORMAT(dat_horinicial, '%Y/%m/%d %H:/%i')";

  const response = await Axios.post(url, {
    tabela: tabela,
    campos: campos,
    condicao: condicao,
    orderBy: orderBy
  });

  console.log('Response OM: ', response);
  if (response.data.statusCode !== 200) { return []; }

  return JSON.parse(response.data.body);
}

// Buscar Ordem de Manutenção
export const buscarOrdem = async (clienteId, ordemId) => {
  const url = Globais.url_consulta

  const tabela = "Tab_OrdManutencao a LEFT JOIN Tab_Equipamentos b on a.cod_cliente = b.cod_cliente "
    + "AND a.cod_equipamento = b.cod_equipamento "
    + "LEFT JOIN Tab_Desvios c on a.cod_cliente = c.cod_cliente AND a.cod_desvio = c.cod_desvio";

  const campos = "num_ordmanutencao, a.cod_equipamento as cod_equipamento, mod_equipamento, tag_equipamento, "
    + "COALESCE(hor_manutencao, '') AS hor_manutencao, COALESCE(res_ordmanutencao, '') AS res_ordmanutencao, "
    + "DATE_FORMAT(dat_horinclusao, '%d/%m/%Y %H:%i') AS dat_horinclusao, DATE_FORMAT(dat_horinicial, '%d/%m/%Y %H:%i') AS dat_horinicial, "
    + "DATE_FORMAT(dat_horfinal, '%d/%m/%Y %H:%i') AS dat_horfinal, COALESCE(obs_ordmanutencao, '') AS obs_ordmanutencao, "
    + "COALESCE(a.cod_desvio, '') as cod_desvio, COALESCE(des_desvio, '') AS des_desvio, "
    + "COALESCE(idt_fotdesvio, '') AS idt_fotdesvio, COALESCE(idt_docaprovacao, '') AS idt_docaprovacao, "
    + "COALESCE(idt_basequipamento, '') AS idt_basequipamento, sit_ordmanutencao";

  const condicao = "a.cod_cliente = " + clienteId + " AND a.cod_ordmanutencao = " + ordemId;

  const orderBy = "";

  const response = await Axios.post(url, {
    tabela: tabela,
    campos: campos,
    condicao: condicao,
    orderBy: orderBy
  });

  if (response.data.statusCode !== 200) { return []; }

  return JSON.parse(response.data.body);
}

// Incluir Ordem de Manutenção
export const incluirOrdem = async (ordem) => {
  const url = Globais.url_inclusao_ordem;
  console.log('url: ', url);

  const ordemId = await defineCodigoOrdem();

  const fotoBase64 = ordem.fotoDesvio ? await toBase64(ordem.fotoDesvio) : null;

  const response = await Axios.post(url, {
    clienteId: ordem.clienteId,
    ordemId: ordemId,
    numero: ordem.numero,
    dataInclusao: ordem.dataInclusao,
    responsavel: ordem.responsavel,
    equipamentoId: ordem.equipamentoId,
    horas: ordem.horas,
    dataInicial: ordem.dataInclusao,
    dataFinal: ordem.dataInclusao,
    observacao: ordem.observacao,
    desvioId: ordem.desvioId,
    fotoDesvio: fotoBase64, //ordem.fotoDesvio,
    basculado: ordem.basculado,
    situacao: ordem.situacao,

    bucket: Globais.bucketName,
    folder: Globais.folderName
  });

  console.log('response em incluirOrdem: ', response);

  return JSON.parse(response.data.body);
};

// Atualizar Ordem existente
export const alterarOrdem = async (ordem) => {
  const url = Globais.url_alteracao_ordem;
  console.log('url: ', url);

  const fotoBase64 = ordem.fotoDesvio ? await toBase64(ordem.fotoDesvio) : null;

  // const response = await fetch(`${API_URL}/ordem/${ordem.ordemId}`, {
  //   method: "PUT",
  //   body: formData,
  // });

  // return response.json();

  const response = await Axios.post(url, {
    clienteId: ordem.clienteId,
    ordemId: ordem.ordemId,
    numero: ordem.numero,
    dataInclusao: ordem.dataInclusao,
    responsavel: ordem.responsavel,
    equipamentoId: ordem.equipamentoId,
    horas: ordem.horas,
    dataInicial: ordem.dataInclusao,
    dataFinal: ordem.dataInclusao,
    observacao: ordem.observacao,
    desvioId: ordem.desvioId,
    idtFotoDesvio: ordem.idtFotoDesvio,
    fotoDesvio: fotoBase64, //ordem.fotoDesvio,
    idtDocAprovacao: ordem.idtDocAprovacao,
    docAprovacao: ordem.docAprovacao,
    basculado: ordem.basculado,
    situacao: ordem.situacao,

    bucket: Globais.bucketName,
    folder: Globais.folderName
  });

  console.log('response em alterarOrdem: ', response);

  return JSON.parse(response.data.body);
};

// Excluir uma Ordem de Manutenção
export const excluirOrdem = async (clienteId, ordemId, numero, idtFotoDesvio, idtDocAprovacao) => {

  // const response = await fetch(`${API_URL}/ordem/${ordemId}`, {
  //   method: "DELETE",
  //   headers: { "Content-Type": "application/json" },
  //   body: JSON.stringify({clienteId: clienteId, idtFotoDesvio: idtFotoDesvio}),
  // });
  // //console.log("response em excluirEquipamento em api.js: ", response);
  // return response.json();

  const url = Globais.url_exclusao_ordem;
  console.log('url: ', url);

  console.log('clienteId: ', clienteId);
  console.log('ordemId: ', ordemId);
  console.log('idtFotoDesvio: ', idtFotoDesvio);

  const response = await Axios.post(url, {
    clienteId: clienteId,
    ordemId: ordemId,
    numero: numero,
    idtFotoDesvio: idtFotoDesvio,
    idtDocAprovacao: idtDocAprovacao,

    bucket: Globais.bucketName,
    folder: Globais.folderName,
    folderDocName: Globais.folderDocName
  });

  console.log('response em excluirOrdem: ', response);

  return JSON.parse(response.data.body);
};


//ANÁLISES
// Listar todas as Análises
export const listarAnalises = async (clienteId, ordemId, equipamentoId) => {
  const url = Globais.url_consulta

  const tabela = "Tab_Analises a LEFT JOIN Tab_Compartimentos b on b.cod_cliente = a.cod_cliente " +
    "AND b.cod_equipamento = a.cod_equipamento AND b.cod_compartimento = a.cod_compartimento";

  const campos = "dat_horinclusao, DATE_FORMAT(dat_horinclusao, '%d/%m/%Y %H:%i') AS dat_horinclusao, " +
    "DATE_FORMAT(dat_horinicial, '%d/%m/%Y %H:%i') AS dat_horinicial, " +
    "res_inianalise, res_nasinicial, idt_creinicial, COALESCE(idt_fotinicial, '') AS idt_fotinicial, " +
    "DATE_FORMAT(dat_horfinal, '%d/%m/%Y %H:%i') AS dat_horfinal, " +
    "res_fimanalise, res_nasfinal, idt_crefinal, COALESCE(idt_fotfinal, '') AS idt_fotfinal, " +
    "COALESCE(idt_fotbujao, '') AS idt_fotbujao, COALESCE(idt_fotfiltro, '') AS idt_fotfiltro, obs_analise, sit_analise, " +
    "a.cod_compartimento, b.tip_compartimento "

  const condicao = "a.cod_cliente = " + clienteId + " AND a.cod_ordmanutencao = " + ordemId + " AND a.cod_equipamento = " + equipamentoId
  const orderBy = "";

  const response = await Axios.post(url, {
    tabela: tabela,
    campos: campos,
    condicao: condicao,
    orderBy: orderBy
  });

  if (response.data.statusCode !== 200) { return []; }

  return JSON.parse(response.data.body);
};

// Localizar Análise
export const buscarAnalise = async (clienteId, ordemId, equipamentoId, compartimentoId) => {
  const url = Globais.url_consulta

  const tabela = "Tab_Analises a LEFT JOIN Tab_Compartimentos b on a.cod_cliente = b.cod_cliente " +
    "AND b.cod_equipamento = a.cod_equipamento AND b.cod_compartimento = a.cod_compartimento ";

  const campos = "DATE_FORMAT(dat_horinclusao, '%d/%m/%Y %H:%i') AS dat_horinclusao, " +
    "COALESCE(DATE_FORMAT(dat_horinicial, '%d/%m/%Y %H:%i'), '') AS dat_horinicial, " +
    "COALESCE(res_inianalise, '') AS res_inianalise, COALESCE(res_nasinicial, '') AS res_nasinicial, " +
    "COALESCE(idt_creinicial, '') AS idt_creinicial, COALESCE(idt_fotinicial, '') AS idt_fotinicial, " +
    "COALESCE(DATE_FORMAT(dat_horfinal, '%d/%m/%Y %H:%i'), '') AS dat_horfinal, " +
    "COALESCE(res_fimanalise, '') AS res_fimanalise, COALESCE(res_nasfinal, '') AS res_nasfinal, " +
    "COALESCE(idt_crefinal, '') AS idt_crefinal, COALESCE(idt_fotfinal, '') AS idt_fotfinal, " +
    "COALESCE(idt_fotbujao, '') AS idt_fotbujao, COALESCE(idt_fotfiltro, '') AS idt_fotfiltro, " +
    "COALESCE(obs_analise, '') AS obs_analise, sit_analise, tip_compartimento ";

  const condicao = "a.cod_cliente = " + clienteId +
    " AND a.cod_ordmanutencao = " + ordemId +
    " AND a.cod_equipamento = " + equipamentoId +
    " AND a.cod_compartimento = " + compartimentoId;

  const orderBy = "";

  const response = await Axios.post(url, {
    tabela: tabela,
    campos: campos,
    condicao: condicao,
    orderBy: orderBy
  });

  if (response.data.statusCode !== 200) { return []; }

  return JSON.parse(response.data.body);
};

// Criar nova Análise
export const incluirAnalise = async (analise) => {
  const url = Globais.url_inclusao_analise;
  console.log('url: ', url);

  const fotoInicial64 = analise.fotoinicial ? await toBase64(analise.fotoinicial) : null;
  const fotoFinal64 = analise.fotofinal ? await toBase64(analise.fotofinal) : null;
  const fotoBujao64 = analise.fotobujao ? await toBase64(analise.fotobujao) : null;
  const fotoFiltro64 = analise.fotofiltro ? await toBase64(analise.fotofiltro) : null;

  console.log('Datas OM', analise.datainicialOM, analise.datafinalOM);

  const response = await Axios.post(url, {
    clienteId: analise.clienteId,
    ordemId: analise.ordemId,
    equipamentoId: analise.equipamentoId,
    compartimentoId: analise.compartimentoId,
    datainclusao: analise.datainclusao,

    datahorainicial: analise.datahorainicial,
    resinianalise: analise.resinianalise,
    resnasinicial: analise.resnasinicial,
    idtcreinicial: analise.idtcreinicial,
    fotoinicial: fotoInicial64,

    datahorafinal: analise.datahorafinal,
    resfimanalise: analise.resfimanalise,
    resnasfinal: analise.resnasfinal,
    idtcrefinal: analise.idtcrefinal,
    fotofinal: fotoFinal64,

    fotobujao: fotoBujao64,
    fotofiltro: fotoFiltro64,

    observacao: analise.observacao,
    situacao: analise.situacao,

    datainicialOM: analise.datainicialOM,
    datafinalOM: analise.datafinalOM,

    bucket: Globais.bucketName,
    folder: Globais.folderName
  });

  console.log('response em incluirDocAprovacao: ', response);

  return JSON.parse(response.data.body);
};

// Atualizar Análise existente
export const alterarAnalise = async (analise) => {
  const url = Globais.url_alteracao_analise;
  console.log('url: ', url);

  const fotoInicial64 = analise.fotoinicial ? await toBase64(analise.fotoinicial) : null;
  const fotoFinal64 = analise.fotofinal ? await toBase64(analise.fotofinal) : null;
  const fotoBujao64 = analise.fotobujao ? await toBase64(analise.fotobujao) : null;
  const fotoFiltro64 = analise.fotofiltro ? await toBase64(analise.fotofiltro) : null;

  const response = await Axios.post(url, {
    clienteId: analise.clienteId,
    ordemId: analise.ordemId,
    equipamentoId: analise.equipamentoId,
    compartimentoId: analise.compartimentoId,
    dataInclusao: analise.dataInclusao,

    datahorainicial: analise.datahorainicial,
    resinianalise: analise.resinianalise,
    resnasinicial: analise.resnasinicial,
    idtcreinicial: analise.idtcreinicial,
    idtfotoinicial: analise.idtfotoinicial,
    fotoinicial: fotoInicial64,
    operacaoFotoInicial: analise.operacaoFotoInicial,

    datahorafinal: analise.datahorafinal,
    resfimanalise: analise.resfimanalise,
    resnasfinal: analise.resnasfinal,
    idtcrefinal: analise.idtcrefinal,
    idtfotofinal: analise.idtfotofinal,
    fotofinal: fotoFinal64,
    operacaoFotoFinal: analise.operacaoFotoFinal,

    idtfotobujao: analise.idtfotobujao,
    fotobujao: fotoBujao64,
    operacaoFotoBujao: analise.operacaoFotoBujao,

    idtfotofiltro: analise.idtfotofiltro,
    fotofiltro: fotoFiltro64,
    operacaoFotoFiltro: analise.operacaoFotoFiltro,

    observacao: analise.observacao,
    situacao: analise.situacao,

    datainicialOM: analise.datainicialOM,
    datafinalOM: analise.datafinalOM,

    bucket: Globais.bucketName,
    folder: Globais.folderName
  });

  console.log('response em alterarAnalise: ', response);

  return JSON.parse(response.data.body);
};

// Excluir uma Análise
export const excluirAnalise = async (analise) => {
  const url = Globais.url_exclusao_analise
  console.log('url: ', url);
  console.log('Analise: ', analise);

  const response = await Axios.post(url, {
    clienteId: analise.clienteId,
    ordemId: analise.ordemId,
    equipamentoId: analise.equipamentoId,
    compartimentoId: analise.compartimentoId,
    idtfotoinicial: analise.idtfotoinicial,
    idtfotofinal: analise.idtfotofinal,
    idtfotobujao: analise.idtfotobujao,
    idtfotofiltro: analise.idtfotofiltro,
    datainicialOM: analise.datainicialOM,
    datafinalOM: analise.datafinalOM,
    datainclusaoOM: analise.datainclusaoOM,

    bucket: Globais.bucketName,
    folder: Globais.folderName
  });

  console.log('response em excluirAnalise: ', response);

  return JSON.parse(response.data.body);
};

//DOCUMENTO DE APROVAÇÃO
// Inclusão
export const incluirDocAprovacao = async (documento) => {
  const url = Globais.url_inclusao_documento;
  console.log('url: ', url);

  const docAprovacao64 = documento.docAprovacao ? await toBase64(documento.docAprovacao) : null;

  const response = await Axios.post(url, {
    clienteId: documento.clienteId,
    ordemId: documento.ordemId,
    // idtDocAprovacao: documento.idtDocAprovacao,
    docAprovacao: docAprovacao64,
    // operacaoDocumento: documento.operacaoDocumento,
    bucket: Globais.bucketName,
    folder: Globais.folderDocName
  });

  console.log('response em incluirDocAprovacao: ', response);

  return JSON.parse(response.data.body);
};

// Inclusão
export const alterarDocAprovacao = async (documento) => {
  const url = Globais.url_alteracao_documento;
  console.log('url: ', url);

  const docAprovacao64 = documento.docAprovacao ? await toBase64(documento.docAprovacao) : null;

  const response = await Axios.post(url, {
    clienteId: documento.clienteId,
    ordemId: documento.ordemId,
    idtDocAprovacao: documento.idtDocAprovacao,
    docAprovacao: docAprovacao64,
    // operacaoDocumento: documento.operacaoDocumento,
    bucket: Globais.bucketName,
    folder: Globais.folderDocName
  });

  console.log('response em alterarDocAprovacao: ', response);

  return JSON.parse(response.data.body);
};

// Exclusão
export const excluirDocAprovacao = async (documento) => {
  const url = Globais.url_exclusao_documento;
  console.log('url: ', url);

  const response = await Axios.post(url, {
    clienteId: documento.clienteId,
    ordemId: documento.ordemId,
    idtDocAprovacao: documento.idtDocAprovacao,
    bucket: Globais.bucketName,
    folder: Globais.folderDocName
  });

  console.log('response em excluirDocAprovacao: ', response);

  return JSON.parse(response.data.body);
};

// Relatórios
export const gerarRelatorio = async (parametros, campos) => {
  const url = Globais.url_relatorios;
  console.log('url: ', url);

  console.log('Relatório: ', parametros.relatorio);

  const response = await Axios.post(url, { parametros: parametros, campos: campos });

  console.log('response em gerarRelatorio: ', response);

  return response;
};

// // Upload de imagem para AWS S3
// export const uploadImagem = async (file) => {
//   const formData = new FormData();
//   formData.append("file", file);

//   const response = await fetch(`${API_URL}/upload-imagem`, {
//     method: "POST",
//     body: formData,
//   });
//   // console.log("response uploadImagem em api.js: ", response);

//   return response;
// };

// Verifica se já existe arquivo em processamento
export const verificaProcessamento = async () => {
  const url = Globais.url_consulta

  const tabela = "Tab_ConWebSocket";

  const campos = "COUNT(*) as qtd"

  const condicao = "";
  const orderBy = "";

  const response = await Axios.post(url, {
    tabela: tabela,
    campos: campos,
    condicao: condicao,
    orderBy: orderBy
  });

  if (response.data.statusCode !== 200) { return []; }
  console.log('Response em verificaProcessamento: ', response);

  return JSON.parse(response.data.body);
};

// Upload de arquivo de importação para AWS S3
export const uploadArquivo = async (arquivo, user, jobId) => {
  const url = Globais.url_upload_zip;
  console.log('url: ', url);

  const nomeArquivo = arquivo.name;
  console.log('nomeArquivo: ', nomeArquivo);

  // const arquivoBase64 = arquivo ? await toBase64(arquivo) : null;

  let response;

  try {
    // 3. Pede a URL Pré-assinada para a sua API REST existente
    // Executa LambdaIniciaImportacao
    // Verifica se já existe algum arquivo em processamento
    // Se não Gera URKL pré-assinada para upload do arquivo zip
    response = await Axios.post(url, { fileName: nomeArquivo, jobId: jobId });

    console.log('response em uploadArquivo: ', response);

    if (response.data.statusCode === 200) {
      const { uploadUrl } = JSON.parse(response.data.body);
      console.log('uploadUrl: ', uploadUrl);

      // 4. Envia o arquivo para o S3 usando a URL gerada
      // Executa uplaod do arquivo zip para o S3
      await Axios.put(uploadUrl, arquivo, {
        headers: {
          "Content-Type": "application/zip"
        }
        ,
        // [Opcional] Para atualizar a barrinha só enquanto o arquivo sobe da máquina para o S3
        onUploadProgress: (progressEvent) => {
          const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          // Podemos considerar que o upload pro S3 é os primeiros 20% do processo todo
          // console.log("Upload para nuvem concluído: ", percent, "%"); 
        }
      });
    }

    console.log('Upload finalizado! Aguardando o Lambda assumir via WebSocket...');

  } catch (error) {
    console.error('Erro no upload para o S3:', error);
    toast.error('Falha ao iniciar o processamento.');
  }

  console.log('response final: ', response);
  return response;
};

// // Upload de PDF assinado
// export const uploadPDFAssinado = async (file) => {
//   const formData = new FormData();
//   formData.append("file", file);

//   const response = await fetch(`${API_URL}/uploadAssinado`, {
//     method: "POST",
//     body: formData,
//   });

//   return response.json();
// };
